var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',_vm._b({},'svg',_vm.svgAttrs,false),[_c('SvgGameMBTI')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }